import axios from 'axios';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}

export default {
    currency() {
        return new Promise(async (resolve, reject) => {
            try {
                const {
                    data
                } = await axios.get("/currency/cbo");
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },

    list(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'kode', 'namabank', 'isbank', 'aktif'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bankcashacc${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    listByUser(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir','username', 'kode', 'namabank', 'isbank', 'aktif'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/bankcashacc/by-user${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    exportxls(obj = {}) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['sortBy', 'sortDir', 'kode', 'namabank', 'isbank', 'aktif'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
    
                let response = await axios({
                    url: `/bankcashacc/exportxls${str}`,
                    method: 'GET',
                    responseType: 'blob', // important
                });
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `Bank-Cash_Account.xlsx`);
                document.body.appendChild(link);
                link.click();
                resolve(link);
            } catch (error) {
                let responseObj = await error.response.data.text();
                errorHandler(JSON.parse(responseObj), reject);
            }
        });
    },
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.frmmode=='add'){
                    await axios.post("bankcashacc", obj);
                } else {
                    await axios.put(`bankcashacc/${encodeURIComponent(obj.kodelama)}`, obj);
                }
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    saveIntoUser(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                if (obj.frmmode=='add'){
                    await axios.post("bankcashacc/by-user", obj);
                } else {
                    await axios.put(`bankcashacc/by-user/${encodeURIComponent(obj.kodelama)}`, obj);
                }
                resolve();
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    remove(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`bankcashacc/${obj.kode}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    removeFromUser(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.delete(`bankcashacc/by-user${obj.kode}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    }
};